import Repository from "./Repository";

const GET_INITIATIVE = "get";
const ADD_INITIATIVE = "add";
const EDIT_INITIATIVE = "edit";
const DELETE_INITIATIVE = "delete";

export default {
  getWellIntiatives(payload) {
    return Repository.post(transformRoute(GET_INITIATIVE), payload);
  },
  addWellIntiatives(payload) {
    return Repository.post(transformRoute(ADD_INITIATIVE), payload);
  },
  editWellIntiatives(payload) {
    return Repository.post(transformRoute(EDIT_INITIATIVE), payload);
  },
  deleteWellIntiatives(payload) {
    return Repository.post(transformRoute(DELETE_INITIATIVE), payload);
  },
};

const transformRoute = (route) => {
  return `wellbeingintiative/${route}`;
};
